import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { PatentSearchApi, PatentSearchRequest, PatentSearchResponse } from '../patent-search-api';
import { GuestAwareHttpService } from '../../services/guest-aware-http-service';

@injectable()
export class PatentSearchApiImpl extends GuestAwareHttpService implements PatentSearchApi {
    async searchPatent(request: PatentSearchRequest): Promise<PatentSearchResponse> {
        const params: Record<string, any> = { q: request.q };
        if (request.limit) params.limit = request.limit;

        return this.getWithGuestSupport<PatentSearchResponse>('patent/autocomplete', params);
    }
}
